import React from "react";

import CompetenceListFieldRow from "core/field/CompetenceListFieldRow";
import FieldBaseRow, { FieldRowProps } from "core/field/FieldBaseRow";
import {
	BooleanField,
	CalculationField,
	CompetenceListField,
	DateField,
	DecimalField,
	FieldType,
	GroupField,
	ImageField,
	IntegerField,
	MultiSelectField,
	RatingField,
	SelectField,
	TextField,
	UploadField,
	UrlField
} from "core/field/FieldService";
import GroupFieldRow from "core/field/GroupFieldRow";
import RatingFieldRow from "core/field/RatingFieldRow";
import BooleanFormFieldExpansion from "./form/BooleanFormFieldExpansion";
import DateFormFieldExpansion from "./form/DateFormFieldExpansion";
import DecimalFormFieldExpansion from "./form/DecimalFormFieldExpansion";
import IntegerFormFieldExpansion from "./form/IntegerFormFieldExpansion";
import MultiSelectFormFieldExpansion from "./form/MultiSelectFormFieldExpansion";
import SelectFormFieldExpansion from "./form/SelectFormFieldExpansion";
import TextFormFieldExpansion from "./form/TextFormFieldExpansion";
import UrlFormFieldExpansion from "./form/UrlFormFieldExpansion";
import ImageFormFieldExpansion from "./form/ImageFormFieldExpansion";
import UploadFormFieldExpansion from "./form/UploadFormFieldExpansion";
import CalculationFormFieldExpansion from "./form/CalculationFormFieldExpansion";

const FieldRow: React.FC<FieldRowProps> = (props: FieldRowProps) => {
	switch (props.field.type) {
		case FieldType.BOOLEAN:
			return (
				<FieldBaseRow {...props}>
					<BooleanFormFieldExpansion
						{...props}
						field={props.field as BooleanField}
					/>
				</FieldBaseRow>
			);
		case FieldType.CALCULATION:
			return (
				<FieldBaseRow {...props}>
					<CalculationFormFieldExpansion
						{...props}
						field={props.field as CalculationField}
					/>
				</FieldBaseRow>
			);
		case FieldType.COMPETENCE_LIST:
			return (
				<CompetenceListFieldRow
					{...props}
					field={props.field as CompetenceListField}
				/>
			);
		case FieldType.DATE:
			return (
				<FieldBaseRow {...props}>
					<DateFormFieldExpansion
						{...props}
						field={props.field as DateField}
					/>
				</FieldBaseRow>
			);
		case FieldType.DECIMAL:
			return (
				<FieldBaseRow {...props}>
					<DecimalFormFieldExpansion
						{...props}
						field={props.field as DecimalField}
					/>
				</FieldBaseRow>
			);
		case FieldType.GROUP:
			return (
				<GroupFieldRow {...props} field={props.field as GroupField} />
			);
		case FieldType.INTEGER: {
			return (
				<FieldBaseRow {...props}>
					<IntegerFormFieldExpansion
						{...props}
						field={props.field as IntegerField}
					/>
				</FieldBaseRow>
			);
		}
		case FieldType.IMAGE:
			return (
				<FieldBaseRow {...props}>
					<ImageFormFieldExpansion
						{...props}
						field={props.field as ImageField}
					/>
				</FieldBaseRow>
			);
		case FieldType.RATING:
			return (
				<RatingFieldRow {...props} field={props.field as RatingField} />
			);
		case FieldType.SELECT:
			return (
				<FieldBaseRow {...props}>
					<SelectFormFieldExpansion
						{...props}
						field={props.field as SelectField}
					/>
				</FieldBaseRow>
			);
		case FieldType.MULTI_SELECT:
			return (
				<FieldBaseRow {...props}>
					<MultiSelectFormFieldExpansion
						{...props}
						field={props.field as MultiSelectField}
					/>
				</FieldBaseRow>
			);
		case FieldType.TEXT:
			return (
				<FieldBaseRow {...props}>
					<TextFormFieldExpansion
						{...props}
						field={props.field as TextField}
					/>
				</FieldBaseRow>
			);
		case FieldType.URL:
			return (
				<FieldBaseRow {...props}>
					<UrlFormFieldExpansion
						{...props}
						field={props.field as UrlField}
					/>
				</FieldBaseRow>
			);
		case FieldType.UPLOAD:
			return (
				<FieldBaseRow {...props}>
					<UploadFormFieldExpansion
						{...props}
						field={props.field as UploadField}
					/>
				</FieldBaseRow>
			);
		default:
			return <FieldBaseRow {...props} />;
	}
};

export default FieldRow;
